import { useMutation } from '@tanstack/react-query';
import { subscribeBackInStock } from '../operations';
import { SubscribeBackInStockProps } from '../operations/subscribe-back-in-stock';

export const useSubscribeBackInStock = () => {
	return useMutation(['subscribeBackInStock'], async (props: SubscribeBackInStockProps) => {
		return await subscribeBackInStock(props);
	});
};
